<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="1000_auto"
      :visible.sync="modalVisible"
  >
    <template #content>
      <div style="text-align: center;">
        <div class="size24 color333 weight600">欢迎进行店铺授权</div>
        <div class="size16 colorOrange" style="padding: 8px 0;">店铺授权作为使用系统的第一步，不如先看一下授权视频详细了解一下吧~</div>
        <video
            src="https://s3.gerpgo.com/cloud/培训视频/店铺授权更新视频.mp4"
            controls
            width="100%"
        >
          您的浏览器不支持播放视频，请使用谷歌浏览器！
        </video>
        <gj-button type="primary" style="margin-top: 12px;" @click="modalVisible=false">不用看，我都知道</gj-button>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";

export default {
  name: "video-modal",
  mixins:[modalMixIn]
}
</script>

<style scoped>

</style>